// toggle the submenu items in the mobile menu
const subMenuToggle = ($) => {
	$('.menu-item-has-children').on('click', function(){

		/// close other menus if they are open 
		$('.menu-item-has-children').not(this).removeClass('js-open-sub-menu');
		
		// open the menu the user clicked on
		$(this).toggleClass('js-open-sub-menu');
	
	})

}

export default subMenuToggle;